
import { PriceFrequency } from "@energy-retailer/constants";
import { Button } from "../button";
import { Text } from "../text";
import clsx from "clsx";


type EstimatedPriceRowProps = {
  priceFrequency: PriceFrequency;
  setValue: (name: string, value: PriceFrequency) => void;
}

const EstimatedPriceRow: React.FC<EstimatedPriceRowProps> = ({ priceFrequency, setValue}) => {
  return (
    <>
      <Text as="p" variant="body2">Estimated Price</Text>
      <div className="grid grid-cols-4 gap-2 mt-2">
        <Button
          className={clsx(priceFrequency === PriceFrequency.Yearly ? "font-semibold" : "font-medium")}
          variant={priceFrequency === PriceFrequency.Yearly ? "primary" : "secondary"} 
          onClick={
            () => setValue('priceFrequency', PriceFrequency.Yearly)
          }>
            Yearly
        </Button>
        <Button 
          className={clsx(priceFrequency === PriceFrequency.Quarterly ? "font-semibold" : "font-medium")}
          variant={priceFrequency === PriceFrequency.Quarterly ? "primary" : "secondary"} 
          onClick={
            () => setValue('priceFrequency', PriceFrequency.Quarterly)
          }>
            Quarterly
        </Button>
        <Button
          className={clsx(priceFrequency === PriceFrequency.Monthly ? "font-semibold" : "font-medium")}
          variant={priceFrequency === PriceFrequency.Monthly ? "primary" : "secondary"} 
          onClick={
            () => setValue('priceFrequency', PriceFrequency.Monthly)
          }>
            Monthly
        </Button>
        <Button
          className={clsx(priceFrequency === PriceFrequency.Weekly ? "font-semibold" : "font-medium")}
          variant={priceFrequency === PriceFrequency.Weekly ? "primary" : "secondary"} 
          onClick={
            () => setValue('priceFrequency', PriceFrequency.Weekly)
          }>
            Weekly
        </Button>
      </div>
    </>
  )
}

export default EstimatedPriceRow;